import { SelectInputField } from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useEphemeralStore } from '../../../state/useEphemeralStore'
import { setUserPref } from '@eventr/common'
import { defaultCurrenciesList } from '../../../state/bookingState/booking.interfaces'

export const CurrencySelector: FC = () => {
    const { filtersObj, setFiltersObj } = useEphemeralStore(
        useShallow((s) => ({
            filtersObj: s.filtersObj,
            setFiltersObj: s.setFiltersObj,
        }))
    )
    return (
        <Box>
            <SelectInputField
                fieldLabel="Currency"
                formControlMarginTop={0}
                defaultValue={filtersObj.currency}
                data={defaultCurrenciesList.map((c) => ({
                    displayName: c.value,
                    id: c.key,
                }))}
                onChange={(event) => {
                    setUserPref(
                        'account',
                        'currency',
                        event.target.value as string
                    )
                    setFiltersObj({
                        ...filtersObj,
                        currency: event.target.value as any,
                    })
                }}
            />
        </Box>
    )
}
